module.exports = __webpack_public_path__ + "img/error404.abc5b048.svg";